import {RefObject} from 'react';
import {MOBILE_HEADER_HEIGHT_PX} from '../header/constants';

export function focusCurrentList({
  listElement,
  isWebView,
}: {
  listElement: RefObject<HTMLElement>;
  isWebView: boolean;
}) {
  if (!listElement || !listElement.current) {
    window.scrollTo(0, 1);
    return;
  }

  window.scrollTo(
    0,
    listElement.current.offsetTop - (isWebView ? 0 : MOBILE_HEADER_HEIGHT_PX)
  );
}
